<template>
  <v-container fluid class="monitorSite stats-boxX elevation-2X px-4 fade-in">
    <v-row>
      <v-col xs="12" center class="pt-2 pb-0">
        <h1>All Office Data Collection Status</h1>
      </v-col>
    </v-row>

    <v-row>
      <!-- LEFT SIDE: FOUR STATUS COUNTS TABLES (Agency, Program, Field, Branch) -->
      <v-col xs="12" md="5">
        <div v-for="(depth, index) in depths" :key="index" class="pt-1">
          <h2 :class="{agency: depth===0, program: depth===1, field: depth===2, branch: depth===3}">
            <span class="type-img" :class="`img-level-${depth}`"></span>
            <span class="type-label"></span>
            Data
          </h2>
          <ag-grid-vue
            style="width: 100%; height: 210px; margin-bottom: 10px;"
            class="ag-theme-balham elevation-2"
            :columnDefs="statsColumnDefs"
            :rowData="stats[depth]"
            @rowClicked="onStatsRowDoubleClicked($event, depth)"
          ></ag-grid-vue>
        </div>
      </v-col>

      <!-- RIGHT SIDE: OFFICE LIST (given selected row on left) -->
      <v-col cols="12" xs="12" md="7">
        <div v-if="offices && offices.length > 0" class="office-list elevation-2">
          <h2 class="mb-2 ml-1">
            <span class="type-img" :class="`img-level-${this.currentDepth}`"></span>
            {{ officeCount }}
            {{ officeType }} {{ reportTypeString }}
          </h2>
          <ag-grid-vue
            style="width: 100%; height: 600px; min-height: 500px;"
            class="ag-theme-balham elevation-2X"
            :columnDefs="officeColumnDefs"
            :rowData="offices"
            :context="context"
          ></ag-grid-vue>
        </div>
        <div v-else>
          <div
            class="no-office"
          >Click on a row in the tables at left to view the list of offices with this status.</div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import { adminDataCollectionService } from "@/services/adminDataCollectionService.js";
import router from "@/router";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "AllOfficeDataCollectionStats",
  components: {
    AgGridVue
  },
  data: () => ({
    currentDepth: 0,
    depths: [0, 1, 2, 3],
    stats: [],
    loading: [false, false, false, false],
    statsColumnDefs: [
      {
        headerName: "Survey status report type",
        field: "officeData",
        sortable: true,
        resizable: true,
        flex: 3,
        cellClass: "text-left"
      },
      {
        headerName: "Number",
        field: "number",
        sortable: true,
        resizable: true,
        flex: 1
      },
      {
        headerName: "Percentage",
        field: "percentage",
        sortable: true,
        resizable: true,
        flex: 1
      }
    ],
    officeColumnDefs: [
      {
        headerName: "Office Name",
        field: "officeName",
        sortable: true,
        resizable: true,
        flex: 3,
        cellClass: "text-left font-weight-medium"
      },
      {
        headerName: "Abbreviation",
        field: "officeAbbreviation",
        sortable: true,
        resizable: true,
        flex: 1,
        cellClass: "text-left"
      },
      {
        headerName: "Department",
        field: "departmentName",
        sortable: true,
        resizable: true,
        flex: 2,
        cellClass: "text-left"
      },
      {
        headerName: "View Office",
        field: "officeId",
        sortable: false,
        resizable: false,
        flex: 1,
        cellRenderer: params => {
          const route = {
            name: "details",
            params: { id: params.value }
          };

          const link = document.createElement("a");
          let router = params.context.componentParent._routerRoot._router;
          link.innerText = "View office";
          link.addEventListener("click", e => {
            e.preventDefault();
            router.push(route);
          });
          return link;
        }
      }
    ],
    reportType: null,
    offices: [],
    links: [],
    context: null,
    statuses: [
      "not logged into the system",
      "logged into the system without saving data",
      "submission in process",
      "ready to submit",
      "submitted final data",
      "total"
    ]
  }),
  methods: {
    onStatsRowDoubleClicked: function (evt, depth) {
      let me = this;
      me.reportType = evt.data.id;
      if (me.reportType === undefined) {
        // hack , undefined = total row
        me.reportType = 5; // const for total (WIP) - talk to DD about right way to do this
      }
      me.currentDepth = depth;
      adminDataCollectionService
        .getOfficeListAtDepthForReport(me.currentDepth, me.reportType)
        .then(function (resp) {
          me.offices = [];
          resp.data.forEach(office => {
            me.offices.push(office);
          });
        })
        .catch(function (err) {
          console.error(err);
        });
    },
    recursiveGetStatsForDepth: function (depth) {
      if (depth > 3) return;
      let me = this;
      let d = depth;
      me.getStatsAtDepth(d, me.recursiveGetStatsForDepth);
    },
    getStatsAtDepth: function (depth, fnCallback) {
      let me = this;
      console.log("beginning loading stats at depth: " + depth);
      Vue.set(me.loading, depth, true);
      adminDataCollectionService
        .getDataCollectionStats(depth)
        .then(function (resp) {
          let finalRow;
          if (resp.data[5].id === 5) {
            let tmp = resp.data.splice(5, 1);
            finalRow = tmp[0];
          }
          let data = resp.data;
          data.push({
            officeData: "Total",
            number: finalRow.number,
            percentage: "100%"
          });
          Vue.set(me.stats, depth, data);
          Vue.set(me.loading, depth, false);
          console.log("completed loading stats at depth: " + depth);
          if (fnCallback && typeof fnCallback === "function") {
            fnCallback(++depth);
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    }
  },
  computed: {
    officeType: function () {
      switch (this.currentDepth) {
        case 1:
          return "Programs";
        case 2:
          return "Field offices";
        case 3:
          return "Branch offices";
        default:
          return "Agencies";
      }
    },
    officeCount: function () {
      return !this.offices || this.offices.length === 0
        ? 0
        : this.offices.length;
    },
    reportTypeString: function () {
      let stat = this.statuses[this.reportType];
      if (!stat) stat = "(All)";
      return stat;
    },
    agencyData: function () {
      return !this.stats || !this.stats[0] ? null : this.stats[0];
    },
    isAgencyDataLoading: function () {
      return !this.loading || !this.loading[0] ? false : this.loading[0];
    },
    programData: function () {
      return !this.stats || !this.stats[1] ? null : this.stats[1];
    },
    isProgramDataLoading: function () {
      return !this.loading || !this.loading[1] ? false : this.loading[1];
    },
    branchData: function () {
      return !this.stats || !this.stats[2] ? null : this.stats[2];
    },
    isBranchDataLoading: function () {
      return !this.loading || !this.loading[2] ? false : this.loading[2];
    },
    fieldData: function () {
      return !this.stats || !this.stats[3] ? null : this.stats[3];
    },
    isFieldDataLoading: function () {
      return !this.loading || !this.loading[3] ? false : this.loading[3];
    }
  },
  created () {
    let me = this;
    me.recursiveGetStatsForDepth(0);
    this.context = { componentParent: this };
  }
};
</script>

<style scoped>
.welcome {
  text-align: left;
  font-size: 14pt;
  font-style: italic;
  margin: 0;
  /* color: #0f5182; */
}
.stats-box {
  border: 1px solid dimgray;
  border-radius: 5px;
  /* background-color: #d8e2f5; */
  background-color: #e8eef9;
}
.admin-section {
  border: 1px solid gray;
  background-color: white;
  border-radius: 5px;
}

.type-img {
  background-size: 26px;
  background-repeat: no-repeat;
  display: inline-block;
  width: 26px;
  height: 26px;
  vertical-align: bottom;
}

/* div.office-list h2 .type-img {
    margin-right: 15px;
} */

h2 {
  padding-left: 5px;
}

h2 .type-img {
  margin-right: 5px;
}

h2.agency .type-label::before {
  content: "Agency";
}
h2.program .type-label::before {
  content: "Program Office";
}
h2.field .type-label::before {
  content: "Field Office";
}
h2.branch .type-label::before {
  content: "Branch Office";
}

.img-level-0 {
  background-image: url(../../assets/agency.png);
}
.img-level-1 {
  background-image: url(../../assets/program.png);
}
.img-level-2 {
  background-image: url(../../assets/field.png);
}
.img-level-3 {
  background-image: url(../../assets/branch.png);
}

</style>
